/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Stages/A3/components/A3EnergySummary.tsx.
 */

import React from "react";

interface Props {
  /** Cumulative embodied energy from all manufacturing fuel rows (MJ). */
  cumulativeMj?: number;
  /** Same as cumulativeMj (legacy prop name). */
  energyMj?: number;
  /** Cumulative ÷ background finished material declared qty, when denominator is known. */
  perDeclaredFinishedMj?: number | null;
  /** Unit for per-finished qty (from Background finished material unit). */
  perFinishedUnitLabel?: string;
}

const A3EnergySummary: React.FC<Props> = ({
  cumulativeMj,
  energyMj,
  perDeclaredFinishedMj,
  perFinishedUnitLabel = "MJ per finished qty",
}) => {
  const mjTotal = Number(cumulativeMj ?? energyMj ?? 0) || 0;

  return (
    <div className="embodied-carbon-summary-container a3-derived-energy-summary">
      <div className="ecs-row">
        <div className="ecs-col ecs-col-left">
          <label className="ecs-label">
            Cumulative embodied energy (all fuels, A3)
          </label>
          <input readOnly value={String(mjTotal)} className="ecs-input" />
        </div>
        <div className="ecs-col ecs-col-right">
          <label className="ecs-label">Unit</label>
          <input readOnly value="MJ" className="ecs-input" />
        </div>
      </div>
      {perDeclaredFinishedMj != null &&
      Number.isFinite(perDeclaredFinishedMj) ? (
        <div className="ecs-row ecs-row-secondary">
          <div className="ecs-col ecs-col-left">
            <label className="ecs-label">
              Embodied energy per functional unit
            </label>
            <input
              readOnly
              value={String(perDeclaredFinishedMj)}
              className="ecs-input"
            />
          </div>
          <div className="ecs-col ecs-col-right">
            <label className="ecs-label">Unit</label>
            <input readOnly value={perFinishedUnitLabel} className="ecs-input" />
          </div>
        </div>
      ) : null}
    </div>
  );
};

/** React component — A3Energy Summary. */
export default A3EnergySummary;
